import { rem } from '../../../utils/rem';
var baseOffset = 48;
export var MuiDialog = {
    styleOverrides: {
        paper: {
            backgroundImage: 'none',
            '& > form': {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                overflowY: 'auto',
            },
        },
    },
    customOverrides: {
        message: function (theme, offsetLeft) { return ({
            '& [class*=MuiDialog-paper]': {
                paddingTop: theme.spacing(3),
            },
            '& [class*=MuiDialogTitle-root].dialog-title-filled  [class*=MuiTypography-root]': {
                paddingInlineStart: rem(baseOffset + offsetLeft),
                paddingTop: 0,
                paddingBottom: 0,
            },
            '& [class*=MuiDialogTitle-root] [class*=MuiTypography-root]': {
                fontSize: '1.125rem',
                paddingInlineStart: rem(baseOffset + offsetLeft),
                paddingTop: 0,
            },
            '& [class*=MuiDialogTitle-root] + [class*=MuiDialogContent-root]': {
                paddingTop: theme.spacing(2),
            },
            '& [class*=MuiDialogContent-root]': {
                display: 'flex',
                flexDirection: 'column',
                gap: theme.spacing(1),
                paddingInlineStart: rem(baseOffset + offsetLeft),
                paddingTop: 0,
            },
            '& [class*=MuiDialogActions-root]': {
                paddingBottom: theme.spacing(2),
            },
            '& .dialog-title-filled': {
                // `offsetLeft` is basically size of the icon used. Because icon is absolutely positioned, this calc has to be used.
                paddingTop: "max(".concat(theme.spacing(3), ", ").concat(offsetLeft / 2 + 12, "px)"),
                paddingBottom: "max(".concat(theme.spacing(3), ", ").concat(offsetLeft / 2 + 10, "px)"),
                marginTop: "-".concat(theme.spacing(3)),
            },
        }); },
    },
};
